import { SystemFuncArgs } from '$legacyecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import DOMOverlay from 'editor/components/DOMOverlay';
import UpdateTextInteraction from 'editor/components/interactions/UpdateTextInteraction';
import Markup from 'editor/components/Markup';
import SheetEvents from 'editor/components/SheetEvents';
import { Components } from '../components';

export const updateTextComponents = [
  CarnivoreDoc,
  CarnivoreSheet,
  DOMOverlay,
  Markup,
  UpdateTextInteraction,
];

export function updateText(args: SystemFuncArgs<Components>): void {
  const { world, entity } = args;

  const carnDoc = entity.get(CarnivoreDoc);
  const sheetComp = entity.get(CarnivoreSheet);
  const domOverlay = entity.get(DOMOverlay);
  const markupComp = entity.get(Markup);
  const interaction = entity.get(UpdateTextInteraction);

  if (!carnDoc) return;
  const { doc } = carnDoc;

  if (!sheetComp) return;
  const { sheet } = sheetComp;

  if (!domOverlay) return;
  const carnDOMOverlay = domOverlay.domOverlay;

  if (!interaction.elAdded) {
    const container = carnDOMOverlay?.getContainer();
    container?.append(interaction.element);

    interaction.elAdded = true;
  }

  if (carnDOMOverlay) {
    const { box, element } = interaction;
    const { left, bottom, right, top } = box;

    // Need to compensate for changes in different screen dpi's.
    const pr = window.devicePixelRatio === 1 ? 1 : 2;
    const c = pr === 1 ? 1 : 0.5;

    // get width and height of textarea
    element.style.width = `${right - left}px`;
    element.style.height = `${top - bottom}px`;

    const rh = doc.reverseHit(box.left, sheet.height - box.top);
    const t = doc.transform;

    element.style.transformOrigin = 'top left';
    element.style.transform = `matrix(${t[0] * c}, ${t[1] * c}, ${t[4] * c}, ${
      t[5] * c
    }, ${rh.x / pr}, ${rh.y / pr})`; // eslint-disable-line

    const blurHandler = () => {
      // TODO: also create markup on escape key hit?
      if (markupComp.mkMarkup && element.value.length > 0) {
        markupComp.mkMarkup.setText(element.value);

        markupComp.selected = true;
        markupComp.hidden = false;

        if (interaction.mode === 'create') {
          world.grabAll(SheetEvents).forEach(({ component }) => {
            component.emit('updatetext:mode-create:onblur', { markupComp });
          });
        } else if (interaction.mode === 'update') {
          world.grabAll(SheetEvents).forEach(({ component }) => {
            component.emit('updatetext:mode-update:onblur', { markupComp });
          });
        }
      }

      element.removeEventListener('blur', blurHandler);
      element.remove();
      entity.destroy();
    };

    if (entity.state !== 'destroying' && document.activeElement !== element) {
      // TODO: Add removing of the blur event handler before entity.destroy().
      element.addEventListener('blur', blurHandler);

      element.focus();
    }
  }
}
